import { render, staticRenderFns } from "./device.vue?vue&type=template&id=4a99c90f&scoped=true"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99c90f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a99c90f')) {
      api.createRecord('4a99c90f', component.options)
    } else {
      api.reload('4a99c90f', component.options)
    }
    module.hot.accept("./device.vue?vue&type=template&id=4a99c90f&scoped=true", function () {
      api.rerender('4a99c90f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/device.vue"
export default component.exports